// extracted by mini-css-extract-plugin
export default {"root":"style_root__Ygvw+","stage":"style_stage__ZBKQf"};